import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import BannerSlot from "../components/BannerSlot";
import { ArrowRight, MapPin } from "lucide-react";

const SERVICE_PREVIEW = [
  ["motorhome-removal", "Motorhome Removal"],
  ["rv-disposal", "RV Disposal"],
  ["boat-removal", "Boat Removal"],
  ["semi-trailer-removal", "Semi-Trailer Removal"],
  ["bus-prevost-removal", "Bus & Prevost"],
  ["airplane-removal", "Airplane Disposal"],
  ["real-property-removal", "Real Property"],
  ["squatter-removal", "Squatter Removal"],
];

export default function CityDetail() {
  const { slug } = useParams();
  const [city, setCity] = useState(null);

  useEffect(() => {
    api.get(`/cities/${slug}`).then(r => setCity(r.data));
  }, [slug]);

  if (!city) return <div className="max-w-7xl mx-auto px-6 py-20" data-testid="city-loading">Loading…</div>;

  return (
    <>
      <section
        className="text-white relative"
        style={{
          background: `linear-gradient(180deg, rgba(11,37,69,0.85) 0%, rgba(11,37,69,0.95) 100%), url('https://images.unsplash.com/photo-1499092346589-b9b6be3e94b2?auto=format&fit=crop&w=2000&q=70') center/cover no-repeat`,
        }}
        data-testid="city-hero"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <Link to="/cities" className="mono text-[11px] tracking-[0.22em] uppercase text-white/70 hover:text-white">← All Cities</Link>
          <div className="flex items-center gap-3 mt-6">
            <MapPin className="w-6 h-6 text-[#FACC15]" />
            <span className="mono text-[12px] tracking-wider uppercase text-[#FACC15]">
              {city.state ? `${city.state}, ${city.country}` : city.country}
            </span>
          </div>
          <h1 className="display-black text-5xl lg:text-7xl uppercase mt-4 leading-[0.95] tracking-tighter">
            Available Removal<br /> in {city.name}.
          </h1>
          <p className="text-lg text-white/85 mt-6 max-w-2xl">
            Independent dispatch for motorhomes, RVs, campers, boats, semi-trailers, buses, aircraft, real property and more — across {city.name} and surrounding metro.
          </p>
          {city.phantom && (
            <p className="text-sm text-[#FACC15] mt-3 mono">
              ★ Coverage available on dispatch — submit intake for confirmation.
            </p>
          )}
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/quote" className="btn-signal">Request Quote in {city.name}</Link>
            <Link to="/large-jobs" className="btn-ghost" style={{ color: "#fff", borderColor: "#fff" }}>Large Job Channel</Link>
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Services in {city.name}</div>
          <h2 className="display-black text-3xl lg:text-4xl uppercase text-[#064E3B] mt-3">All ten divisions, fully active.</h2>

          <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-gray-300 border border-gray-300">
            {SERVICE_PREVIEW.map(([slug, name]) => (
              <Link key={slug} to={`/service/${slug}`} className="bento-card p-6" data-testid={`city-service-${slug}`}>
                <div className="font-bold text-sm text-[#064E3B]">{name}</div>
                <div className="mono text-[10px] tracking-wider text-[#D97706] uppercase mt-2 flex items-center gap-2">Available <ArrowRight className="w-3 h-3" /></div>
              </Link>
            ))}
          </div>

          <div className="mt-12"><BannerSlot placement="homepage_mid" /></div>
        </div>
      </section>
    </>
  );
}
